// What the Log page's photo read says when it could not read the photo.
// A failed read must never leave a number in the field: until 2026-10-01
// it put the TARGET there with "Looks right, log it", so one tap logged an
// in-range alk the keeper never measured. Plain words, no server internals
// (an env var name, an HTTP status), and always the way forward.
const TYPE_IT = {
  hanna: 'Type the number on your checker below.',
  strip: 'Type the value from the colour card below.',
  refract: 'Type what your refractometer shows below.',
};

export function photoReadFailedMessage({
  code = null,
  status = null,
  kind = 'hanna',
  detail = null,
} = {}) {
  const next = TYPE_IT[kind] || 'Type the number below.';
  const c = String(code || '');
  // The reader saw the photo and said why it has no number (a titration
  // tube: the answer is the drop count). Its own words, then the way on.
  if (c === 'unreadable' && typeof detail === 'string' && detail.trim()) {
    const why = detail
      .trim()
      .replace(/\s*(Enter it by hand|Try better lighting or enter manually)\.?$/i, '')
      .slice(0, 300);
    return `${why.replace(/[.!?]?$/, '.')} ${next}`;
  }
  if (c === 'no_api_key' || c.startsWith('blocked') || status === 503) {
    return `Photo reading isn't available right now. ${next}`;
  }
  if (c === 'timeout' || status === 504) {
    return `The photo read took too long. ${next}`;
  }
  return `We couldn't read that photo. ${next}`;
}
